import pino from 'pino';
import { LogObject, PinoLogObject, ROOT_LOG_NAME } from './types';
import { getDeviceInfo } from '@williamhill/rosi-ui-shared/src/lib/device-info';

export type WriteFn = (o: PinoLogObject) => void;

interface Writers {
  development: (delegate: Console) => WriteFn;
  test: (delegate: Console) => WriteFn;
  production: (delegate: Console) => WriteFn;
}

const development = (delegate: Console) => (o: PinoLogObject) => {
  const { ts, level, logName, msg, args } = unwrapLogObject(o);
  delegate[level](`${ts} [${logName.replace(`${ROOT_LOG_NAME}.`, '')}]: ${msg}`, args);
};

const test = development;

const production = (delegate: Console) => (o: PinoLogObject) => {
  const { ts, level, logName, msg, args } = unwrapLogObject(o);
  delegate[level](
    JSON.stringify({
      '@t': ts,
      '@l': level.toUpperCase(),
      '@n': logName,
      '@m': msg,
      device: getDeviceInfoForLog(),
      args: {
        ...args,
        location: location ? location.pathname : '/'
      },
      v: 1
    })
  );
};

const unwrapLogObject = ({ time, level, logName, msg, ...args }: PinoLogObject): LogObject => ({
  ts: new Date(time).toISOString(),
  level: pino.levels.labels[level],
  logName,
  msg,
  args
});

const device = getDeviceInfo();

const getDeviceInfoForLog = () =>
  device
    ? {
        venueId: device.slotId?.venueId,
        deviceType: device.slotId?.type,
        slotNumber: device.slotId?.slotNumber,
        deviceId: device.deviceId
      }
    : {
        deviceType: ''
      };

const writers: Writers = {
  development,
  test,
  production
};

export const getWriter = (delegate: Console): WriteFn =>
  (writers[process.env.NODE_ENV] || writers.production)(delegate);
